import React from 'react'

const Phone = props => (
  <svg width={24} height={24} {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M6.184 0C5.281 0 4.43.353 3.788.993l-.77.772C-.923 5.7-1.018 12.162 2.805 16.17a147.747 147.747 0 005.01 5.005A10.225 10.225 0 0014.896 24a10.31 10.31 0 007.336-3.036l.772-.771a3.375 3.375 0 00.924-3.078 3.38 3.38 0 00-2.062-2.466l-3.745-1.496a3.382 3.382 0 00-1.26-.243c-.907 0-1.758.353-2.399.993l-1.41 1.409a26.421 26.421 0 01-4.379-4.375l1.41-1.409a3.384 3.384 0 00.751-3.655L9.337 2.131A3.378 3.378 0 006.184 0m0 2c.54 0 1.07.312 1.294.874l1.498 3.742a1.386 1.386 0 01-.308 1.498L6.6 10.181a.93.93 0 00-.1 1.203 28.484 28.484 0 006.106 6.1c.161.119.35.176.54.176a.942.942 0 00.664-.276l2.07-2.067a1.39 1.39 0 011.498-.307l3.746 1.496a1.389 1.389 0 01.467 2.272l-.772.772a8.364 8.364 0 01-5.92 2.45 8.235 8.235 0 01-5.702-2.273 144.667 144.667 0 01-4.94-4.937c-3.113-3.262-3.013-8.425.176-11.611l.773-.772c.277-.277.63-.407.98-.407"
    />
  </svg>
)

export default Phone
